import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';

import { reportErrorToSentry } from '#configuration/setup/sentry.ts';

import { apiV2Root } from './apiV2Root.ts';

const isCartRightUnavailableStatus = (payload: unknown) => {
    return typeof payload === 'object' && payload !== null && 'status' in payload && payload.status === 503;
};

export const cartRightUnavailableTrackingMiddleWare: Middleware = () => next => action => {
    if (
        isRejectedWithValue(action) &&
        action.type.startsWith(apiV2Root.reducerPath) &&
        isCartRightUnavailableStatus(action.payload)
    ) {
        reportErrorToSentry(new Error('CartRight API is unavailable (503)'));
    }

    return next(action);
};
